

import React from 'react';
import LicenseInfoOps from './licenseInfoOps';
import { push } from 'connected-react-router';
import PageUrl from './../dispatcher/pageUrl';

import { serverclientPrefix } from '../store';
import Pricing from './pricing';
import ProductIds from '../api/productIds';
import  ProductGuids from '../api/productGuids';

import CallHostApp from '../api/callHostApp';

import ClientCall from '../api/clientCall';

import { LogCategory, log } from '../api/logger';

var Page = require('../constants/page');

var LicenseInfo = require('./licenseInfo');
var LicenseType = require('./licenseType');
var HeaderType = require('./headerType');



export const INIT_USER_STATE = 'state/init_user_state';
export const SEND_TOKEN_TO_HOST = 'state/token_to_host';
export const SEND_HTTP_STATUS_TO_HOST = 'state/status_to_host';
export const GO_TO_PAGE_AND_HEADER = 'state/go_to_page_and_header';
export const GO_TO_PAGE = 'state/go_to_page';
export const GO_TO_HEADER = 'state/go_to_header';

export const GO_BILLING_PAGE = 'state/go_billing_page';
export const SAVE_CARD = 'state/save_card';
export const SELECT_PROFILE = 'state/select_profile';
export const RENEW_LICENSE = 'state/renew_license';
export const PURCHASE_OTHER_PRODUCT = 'state/purchase_other_product';
export const UPGRADE_LICENSE = 'state/upgrade_license';
export const UPGRADE_LICENSE_FROM_FREE_OR_TRIAL= 'state/upgrade_license_from_free_or_trial';
export const BUY_SMALL_STAKES = 'state/buy_small';
export const BUY_FULL_STAKES = 'state/buy_full';
export const BUY_HM3_AND_OMAHA_FULL_STAKES = 'state/buy_hm3_and_omaha_full';
export const BUY_HM3_AND_OMAHA_SMALL_STAKES = 'state/buy_hm3_and_omaha_small';

export const BUY_GUID_PRODUCT = 'state/buy_guid_product';

export const BUY_HM_APPS_VARIANT = 'state/buy_hm_apps_variant';
export const BUY_HM_APPS_VARIANT_FREE = 'state/buy_hm_apps_variant_free';

export const UPGRADE_HM3_AND_OMAHA_FULL_STAKES = 'state/upgrade_hm3_and_omaha_full';
export const UPGRADE_HM3_AND_OMAHA_SMALL_STAKES = 'state/upgrade_hm3_and_omaha_small';


export const START_HM3_TRIAL = 'state/start_hm3_trial';
export const START_HM3_AND_OMAHA_TRIAL = 'state/start_hm3_and_omaha_trial';
export const SWITCH_TO_FREE = 'state/switch_to_free';
export const CHANGE_PRODUCTS = 'state/change_products';
export const BUY_NOW = 'state/buy_now';
export const CLEAR_CREDIT_CARD = 'state/clear_credit_card';
export const RELOAD_LICENSE = 'state/reload_license';
export const SWITCH_USER = 'state/switch_user';
export const START_USING_APP = 'state/start_using_app';
export const CONTINUE_TRIAL = 'state/continue_trial';
export const GO_TO_PAYPAL = 'state/go_to_paypal';
export const CALL_HOST = 'state/call_hm3';

export const SAVE_NETELLER = 'state/save_neteller';
export const SAVE_ERROR = 'state/save_error';
export const SIMPLE_HOST_APP_ACTION = 'state/simple_host_app_action';

export const GO_TO_HMAPP_APP = 'state/go_to_hmapp_app';

export const LOG_FATAL_ERROR = "state/fatal_error";

const initialState = {
    ok: false,
    header: HeaderType.Hm3,

    // true - launched from startup, false - launched when user goes to MyLicenses
    fromStartup: false,
    language: "en",

    // page: billing/card/startTrial
    // field: for input, what field is the error related to?
    //        if the field is missing, it's a processing error
    lastError: { page: 0, errors: {}, success: true},

    siteUrl: "",
    storeUrl: "",
    licenseUrl: "",
    downloadUrl: "",
    downloadRoot: "",

    // ... just in case we need to notify HM3 of any startup issues
    storeStatus: 200,
    // ... just in case we need to notify HM3 of any startup issues
    licensingStatus: 200,

    token: "?",
    session: "",

    // added when we decided to not use sessions on server side (since we can have several machines to handle requests,
    // and a client can be handled by different machines at different times)
    userId: "",
    licenseId:"",
    email: "",
    fingerprint:"",
    enableTrialAbuseCheck:0,

    // just in case ew want to send a fatal error to the server
    //
    // Workflow:
    // 1. check if error was already added, if so, do nothing
    // 2. add the error here,
    // 3. call the server - only for the first 5 errors, no point in doing this too many times
    fatalErrors: [],

    licenseHm3: LicenseInfo.create(),
    licenseOmaha: LicenseInfo.create(),
    licenseHmApps: LicenseInfo.create(),

    // copy of one of the above
    license: LicenseInfo.create(),

    missedUpdates: [],

    // to be computed on login
    startPage: Page.None,
    currentPage: Page.None,

    // preselected buy option
    // 0 - credit card
    // 1 - neteller
    // 2 - saved profile
    // 3 - paypal
    preselectedBuyAction: { preselect: 0},

    savedCard: {},
    billingAddress: {},
    buyNow: {},
    activeHmAppProductId:"",

    products: [],
    profiles: [],

    hmApps: [],
    subscribedHmApps:[],
    storeAppMap:[],
    buyProductId: -1,
    availableTrials:{hm3: false, omaha: false}
};

export const clearLastError = { page: 0, errors: {}, success: true};
    
export const computeStartPage = (lic,fromStartup) => {
    if ( lic.state == LicenseType.CouldNotStart)
        return Page.CouldNotLoadMla;

    if ( lic.isOverMaxVersion) {
        if ( lic.hasAvailableTrial && fromStartup) {
            // MLA-123
            return Page.PreSelectProducts;
        }
        return Page.FreemiumOverMaxVersion;
    }

    switch ( lic.state) {
        case LicenseType.NoLicense:
            // MLA-123
            return lic.hasAvailableTrial ? Page.PreSelectProducts : Page.SelectProducts;

        case LicenseType.Trial:
            if (!LicenseInfoOps.isExpired(lic)) {
                return fromStartup ? Page.ContinueTrial : Page.TrialLicense;
            }
            break;
    }

    // check license state
    switch ( lic.state) {
        case LicenseType.Trial:
            return Page.TrialLicense;

        case LicenseType.Freemium:

            return Page.Freemium;
        case LicenseType.Maintenance:
            if ( LicenseInfoOps.isFullStakes(lic)) {
                if ( LicenseInfoOps.isExpired(lic))
                    return Page.ExpiredContractFull;
                else if ( LicenseInfoOps.isExpiring(lic))
                    return Page.ExpiringContractFull;
                else
                    return Page.ActiveMaintenanceFull;
            }
            else {
                if ( LicenseInfoOps.isExpired(lic))
                    return Page.ExpiredContractSmall;
                else if ( LicenseInfoOps.isExpiring(lic))
                    return Page.ExpiringContractSmall;
                else
                    return Page.ActiveMaintenanceSmall;
            }
            break;
    }
    console.assert(false);
    return Page.Purchase;
};

// MLA-19
export const computePurchasePage = (lic, fromStartup) => {
    return computeStartPage(lic, fromStartup);
};

// MLA-19
export const computeContinueTrialHeader = state => {
    // if trial -> use that
    if ( state.licenseHm3.state == LicenseType.Trial)
        return HeaderType.Hm3;
    if ( state.licenseOmaha.state == LicenseType.Trial)
        return HeaderType.Omaha;

    // if freemium -> use that
    if ( state.licenseHm3.state == LicenseType.Freemium)
        return HeaderType.Hm3;
    if ( state.licenseOmaha.state == LicenseType.Freemium)
        return HeaderType.Omaha;

    // no trials
    return HeaderType.Hm3;
};




const actionToPage = (type) => {
    switch (type) {
        case SAVE_CARD:
            return Page.Purchase;

        case UPGRADE_LICENSE_FROM_FREE_OR_TRIAL:
            return Page.SelectProducts;

        case RENEW_LICENSE:
        case PURCHASE_OTHER_PRODUCT:
        case UPGRADE_LICENSE:
        case BUY_SMALL_STAKES:
        case BUY_FULL_STAKES:
        case BUY_HM_APPS_VARIANT:
        case BUY_GUID_PRODUCT:
        case BUY_HM3_AND_OMAHA_FULL_STAKES:
        case BUY_HM3_AND_OMAHA_SMALL_STAKES:
        case UPGRADE_HM3_AND_OMAHA_FULL_STAKES:
        case UPGRADE_HM3_AND_OMAHA_SMALL_STAKES:
            return Page.Purchase;

        case START_HM3_TRIAL:
            return Page.TrialStarted;
        case START_HM3_AND_OMAHA_TRIAL:
            return Page.TrialStarted;
        case SWITCH_TO_FREE:
            return Page.Freemium;
        case BUY_NOW:
            return Page.PurchaseCompleteSuccess;
        case BUY_HM_APPS_VARIANT_FREE:
            return Page.SelectHmAppVariantProducts;
        default:
            console.assert(false);
            return Page.Purchase;
    }
};


export default  (state = initialState, action) => {
    if ( typeof action === 'undefined')
        return {...state};

    switch (action.type) {
        // this is just for simulation - can't otherwise set the whole state at once
        case INIT_USER_STATE:
            //log(LogCategory.info,serverclientPrefix + 'initializing user state' + JSON.stringify(action.userState));
            return  { ...state,
                ok: action.userState.ok,

                language: action.userState.language,

                fatalErrors: [],

                siteUrl: action.userState.siteUrl,
                storeUrl: action.userState.storeUrl,
                licenseUrl: action.userState.licenseUrl,
                downloadUrl: action.userState.downloadUrl,

                header: action.userState.header,
                token: action.userState.token,
                session: action.userState.session,

                licensingStatus: action.userState.licensingStatus,
                storeStatus: action.userState.storeStatus,


                userId: action.userState.userId,
                licenseId: action.userState.licenseId,
                email: action.userState.userEmail,
                fingerprint: action.userState.fingerprint,
                enableTrialAbuseCheck: action.userState.enableTrialAbuseCheck,


                licenseHm3: action.userState.licenseHm3,
                licenseOmaha: action.userState.licenseOmaha,
                licenseHmApps: action.userState.licenseHmApps,
                license: action.userState.license,
                missedUpdates: action.userState.missedUpdates,
                restrictions: action.userState.restrictions,
                startPage: action.userState.startPage,
                currentPage: action.userState.currentPage,
                products: action.userState.products,
                profiles: action.userState.profiles,
                buyProductId: action.userState.buyProductId,
                fromStartup: action.userState.fromStartup,
                availableTrials: action.userState.availableTrials,

                hmApps: action.userState.hmApps,
                subscribedHmApps: action.userState.subscribedHmApps,
                storeAppMap: action.userState.storeAppMap,
                userSubscriptions: action.userState.userSubscriptions,

                preselectedBuyAction: { preselect: 0},
                savedCard: {},
                billingAddress: {},
                buyNow: {},
            };

        case GO_BILLING_PAGE:
            return {
                ...state,
                savedCard: action.savedCard,
                currentPage: Page.BillingAddress,
            };

        // note: the saved card details (savedCard/billingInfo) are kept untiil the user does a purchase
        case SAVE_CARD:
            let saveCardBuyAction = action.preselectedBuyAction;
            saveCardBuyAction.profile.savedCard = state.savedCard;
            // note: saved card info is kept until the purchase is fully successful - in case there's an error,
            //       we want the user to be able to continue from where he left off
            return {
                ...state,
                preselectedBuyAction: saveCardBuyAction,
                billingAddress: saveCardBuyAction.preselect.billingAddress,
                currentPage: Page.PaymentReview,
            };

        case SAVE_NETELLER:
            return {
                ...state,
                preselectedBuyAction: action.preselectedBuyAction,
                currentPage: Page.PaymentReview,
            };
        case SELECT_PROFILE:
            return {
                ...state,
                preselectedBuyAction: action.preselectedBuyAction,
            };

        case BUY_NOW:
            return {
                ...state,
                // clear any sensitive data may be been saved
                savedCard: {},
                billingAddress: {},
                preselectedBuyAction: { preselect: 0},
                currentPage: Page.PurchaseCompleteSuccess
            };

        case CLEAR_CREDIT_CARD:
            return {
                ...state,
                // clear any sensitive data may be been saved
                savedCard: {},
                billingAddress: {},
                preselectedBuyAction: { preselect: 0},
            };


        case SEND_TOKEN_TO_HOST:
            // reset the token once sent back to host
            return {...state, token: "" };
        case SEND_HTTP_STATUS_TO_HOST:
            return {...state, licensingStatus: 200, storeStatus: 200};

        case SAVE_ERROR:
            return {...state, lastError: action.error };


        case GO_TO_PAGE:
            return {
                ...state,
                currentPage: action.newPage
            };

        case GO_TO_HEADER:
        {
            let copy = LicenseInfo.copy(action.license);
            let startPage = computeStartPage(action.license, action.fromStartup);
            return {
                ...state,
                license: copy,
                header: action.header,
                currentPage: startPage,
                startPage: startPage
            };
        }


        case GO_TO_PAGE_AND_HEADER:
        {
            let copy = LicenseInfo.copy(action.license);
            return {
                ...state,
                license: copy,
                header: action.header,
                currentPage: action.page
            };
        }
        case LOG_FATAL_ERROR:
            var newErrors = [];
            for ( var e in state.fatalErrors)
                newErrors.push( state.fatalErrors[e]);
            newErrors.push(action.errorNow);
            return {
                ... state,
                fatalErrors: newErrors
            };



        case RENEW_LICENSE:
        case PURCHASE_OTHER_PRODUCT:
        case UPGRADE_LICENSE:
        case UPGRADE_LICENSE_FROM_FREE_OR_TRIAL:
        case BUY_SMALL_STAKES:
        case BUY_FULL_STAKES:
        case BUY_HM_APPS_VARIANT:
        case BUY_GUID_PRODUCT:

        case UPGRADE_HM3_AND_OMAHA_FULL_STAKES:
        case UPGRADE_HM3_AND_OMAHA_SMALL_STAKES:

        case BUY_HM3_AND_OMAHA_FULL_STAKES:
        case BUY_HM3_AND_OMAHA_SMALL_STAKES:
            log(LogCategory.info,"buying " + action.buyProductId);
            return {
                ...state,
                buyProductId: action.buyProductId,
                currentPage: Page.Purchase,
            };

        case BUY_HM_APPS_VARIANT_FREE:
            return {
                ...state,
                currentPage: Page.SelectHmAppVariantProducts,
            };

        case START_HM3_TRIAL:
            return {
                ...state,
                currentPage: actionToPage(action.type)
            };
        case START_HM3_AND_OMAHA_TRIAL:
            return {
                ...state,
                currentPage: actionToPage(action.type)
            };

        case SWITCH_TO_FREE:
            return {
                ...state,
                currentPage: actionToPage(action.type)
            };
        case CHANGE_PRODUCTS:
            var newPage = Page.PreSelectProducts;
            return {
                ...state,
                currentPage: newPage
            };

        case RELOAD_LICENSE:
        case START_USING_APP:
        case CONTINUE_TRIAL:
            return {
                ...state,
                currentPage: state.startPage
            };


        case SIMPLE_HOST_APP_ACTION:
        case CALL_HOST:
            log(LogCategory.info,"call hm3" );
            return {...state};
        case GO_TO_HMAPP_APP: 
        return {...state, activeHmAppProductId: action.activeHmAppProductId };

        default:
            return state;
    }
};

// whole user state
export const initUserState = userState => dispatch =>
    new Promise(resolve => {
        dispatch({
            type: INIT_USER_STATE,
            userState: userState
        });

        resolve(userState);
    });





export const goToPageAndHeader = pageAndHeader => dispatch =>
    new Promise((resolve, reject) => {
        dispatch({
            type: GO_TO_PAGE_AND_HEADER,
            header: pageAndHeader.header,
            license: pageAndHeader.license,
            page: pageAndHeader.page
        });

        dispatch(push( PageUrl(pageAndHeader.page) ));

        resolve(pageAndHeader);
    });



export const goToPage = (page,args) => dispatch =>
    new Promise((resolve, reject) => {
        // clear error first
        dispatch({ type: SAVE_ERROR, error: clearLastError} );

        dispatch({
            type: GO_TO_PAGE,
            newPage: page
        });

        dispatch(push( PageUrl(page,args) ));

        resolve(page,args);
    });

export const goToHmAppPage = activeHmAppProductId => dispatch =>
    new Promise((resolve, reject) => {
        dispatch({
            type: GO_TO_HMAPP_APP,
            activeHmAppProductId: activeHmAppProductId
        });

        dispatch(push( PageUrl(Page.SelectHmAppVariantProducts) ));

        resolve(activeHmAppProductId);
    });

export const goToHeader = header => dispatch =>
    new Promise((resolve, reject) => {
        var startPage = computeStartPage(header.license, header.fromStartup);
        if ( header.header == HeaderType.HmApps)
            startPage = Page.SelectHmAppsProducts;

        dispatch({
            type: GO_TO_HEADER,
            license: header.license,
            header: header.header,
            fromStartup: header.fromStartup
        });

        dispatch(push( PageUrl(startPage) ));

        resolve(header);
    });

export const goBillingPage = card => dispatch =>
    new Promise((resolve, reject) => {
        dispatch({
            type: GO_BILLING_PAGE,
            savedCard: card,
        });

        dispatch(push( PageUrl(Page.BillingAddress) ));

        resolve(card);
    });


export const callHost = str => dispatch =>
    new Promise((resolve, reject) => {
        dispatch({
            type: CALL_HOST,
            callback: str
        });
        CallHostApp.callHost(str);
        resolve(str);
    });

export const goToPaypal = (state) => dispatch =>
    new Promise((resolve, reject) => {

        // ... just in case we get an error - visually show it relates to paypal
        dispatch({
            type: SAVE_NETELLER,
            preselectedBuyAction: {
                preselect: 3, profile: {
                    "paymentProfileId": GO_TO_PAYPAL,
                    "label": "      ",
                    "creditCardType": "PP",
                }
            },
        });

        ClientCall.paypal(state).then(value => {
            // buyNow returns an "error" answer
            dispatch({ type: SAVE_ERROR, error: value} );

            if ( value.success) {
                // get the url and open it in browser
                CallHostApp.openPaypal(value.redirectUrl);
                dispatch(push(PageUrl( Page.Paypal )));
            }
            else
                // the error tells us the page to go to
                dispatch(push(PageUrl( value.page )));

            resolve(state);
        });

    });


export const sendTokenToHost = state => dispatch =>
    new Promise(resolve => {
        CallHostApp.sendTokenToHost(state.token);
        var t = SEND_TOKEN_TO_HOST;
        dispatch({
            type: t,
        });

        resolve(state);
    });


// select profile -> dispatch action, but don't change the UI
export const selectProfile = profile => dispatch =>
    new Promise(resolve => {
        var t = SELECT_PROFILE;
        dispatch({
            type: t,
            preselectedBuyAction: { preselect: 2, profile: profile },
        });
        resolve(profile);
    });


export const saveCard = billingAddress => dispatch =>
    new Promise(resolve => {
        // use savedCard + billingAddress
        var t = SAVE_CARD;
        dispatch({
            type: t,
            preselectedBuyAction: { preselect: 0, profile: {
                "paymentProfileId": SAVE_CARD,
                "label": billingAddress.savedCardInfo,
                "creditCardType": "VS",
                billingAddress: billingAddress,
            } },
        });
        dispatch(push( PageUrl( Page.PaymentReview) ));
        resolve(billingAddress);
    });



export const saveNeteller = (neteller,state) => dispatch =>
    new Promise(resolve => {

        // first, verify this neteller account (just the account number).
        // if that is ok, then we save the neteller username+password
        ClientCall.netellerVerify(neteller.siteUrl, neteller.session, neteller.account, state.userId, state.email).then(value => {

            if ( value.details !== undefined)
            // note: in the details -> the store sends me the "success", and the redirectUrl
                value = value.details;

            if ( value.success) {
                dispatch({ type: SAVE_ERROR, error: {page: 0, success: true, errors: []} } );

                // user is verified, we need to see if it's given HM3 permission for purchase
                dispatch({
                    type: SAVE_NETELLER,
                    preselectedBuyAction: {
                        preselect: 1, profile: {
                            "paymentProfileId": SAVE_NETELLER,
                            "label": "      ",
                            "creditCardType": "NT",
                            neteller: {account: neteller.account, secureId: neteller.secureId, password: neteller.password}
                        }
                    },
                });

                if ( value.redirectUrl === undefined) {
                    // success:true, no redirectUrl
                    // in this case -> user is verified + we (HM3) have permission for purchase
                    dispatch(push(PageUrl(Page.PaymentReview)));
                }
                else {
                    // success:true, redirectUrl
                    // user is verified, but we don't yet have permission -> ask for it now
                    CallHostApp.netellerRedirect(value.redirectUrl);
                }
            }
            else {
                // at this time, I don't get an error from store
                dispatch({ type: SAVE_ERROR, error: {success:false, page: Page.Netteller,
                    errors:{ general:[{message: "Invalid NETELLER account. Please double check your account email address or account ID."}] } } } );

                // success:false from store - just show it visually via alertred (very likely, user is not allowed to do purchase)
                dispatch({
                    type: SAVE_NETELLER,
                    preselectedBuyAction: {
                        preselect: -2,
                    },
                });
                dispatch(push(PageUrl(Page.Netteller)));
            }
            resolve(neteller);
        });
    });

export const saveError = lastError => dispatch =>
    new Promise((resolve, reject) => {
        dispatch({
            type: SAVE_ERROR,
            error: lastError
        });
        resolve(lastError);
    });

export const buyNow = state => dispatch =>
    new Promise(resolve => {
        ClientCall.buyNow(state).then(value => {
            // buyNow returns an "error" answer
            dispatch({ type: SAVE_ERROR, error: value} );

            if ( value.success) {
                dispatch({
                    type: BUY_NOW,
                });
                dispatch(push(PageUrl( Page.PurchaseCompleteSuccess )));
                CallHostApp.needsReloadLicense();
            }
            else
                // the error tells us the page to go to
                dispatch(push(PageUrl( value.page )));

            resolve(state);
        });

    });




export const clearCreditCard = () => dispatch =>
    new Promise(resolve => {
        log(LogCategory.info,"credit card cleared");
        dispatch({
            type: CLEAR_CREDIT_CARD,
        });
        resolve({});
    });


export const renewLicense = state => dispatch =>
    new Promise(resolve => {
        var t = RENEW_LICENSE;
        dispatch({
            type: t,
            buyProductId: Pricing.renewLicenseGuid(state)
        });
        dispatch(push( PageUrl( actionToPage(t)) ));
        resolve(state);
    });

export const purchaseOtherProduct = state  => dispatch =>
    new Promise(resolve => {
        var t = PURCHASE_OTHER_PRODUCT;
        dispatch({
            type: t,
            buyProductId: Pricing.otherProductGuid(state)
        });
        dispatch(push( PageUrl( actionToPage(t)) ));
        resolve(state);
    });

export const upgradeLicense = state => dispatch =>
    new Promise(resolve => {
        var t = UPGRADE_LICENSE;
        dispatch({
            type: t,
            buyProductId: Pricing.upgradeLicenseGuid(state)
        });
        dispatch(push( PageUrl( actionToPage(t)) ));
        resolve(state);
    });

export const upgradeLicenseFromFreeOrTrial = state => dispatch =>
    new Promise(resolve => {
        dispatch({
            type: GO_TO_PAGE,
            newPage: Page.SelectProducts
        });
        dispatch(push( PageUrl( Page.SelectProducts ) ));
        resolve(state);
    });


export const buySmallStakes = state => dispatch =>
    new Promise(resolve => {
        var t = BUY_SMALL_STAKES;
        var isHm3 = state.license.headerType == HeaderType.Hm3;
        var id = isHm3 ? ProductIds.hm3SmallStakes : ProductIds.omahaSmallStakes;
        dispatch({
            type: t,
            buyProductId: Pricing.idToBuyProductGuid(id, state)
        });
        dispatch(push( PageUrl( actionToPage(t)) ));
        resolve(state);
    });

export const buyAllStakes = state => dispatch =>
    new Promise(resolve => {
        var t = BUY_FULL_STAKES;
        var isHm3 = state.license.headerType == HeaderType.Hm3;
        var id = isHm3 ? ProductIds.hm3AllStakes : ProductIds.omahaAllStakes;
        dispatch({
            type: t,
            buyProductId: Pricing.idToBuyProductGuid(id, state)
        });
        dispatch(push( PageUrl( actionToPage(t)) ));
        resolve(state);
    });

export const buyHm3AndOmahaFullStakes = state => dispatch =>
    new Promise(resolve => {
        var t = BUY_HM3_AND_OMAHA_FULL_STAKES;
        dispatch({
            type: t,
            buyProductId:  Pricing.purchaseBothAllGuidIncludeUpgradeAllCombo(state)
        });
        dispatch(push( PageUrl( actionToPage(t)) ));
        resolve(state);
    });

export const buyHm3AndOmahaSmallStakes = state => dispatch =>
    new Promise(resolve => {
        var t = BUY_HM3_AND_OMAHA_SMALL_STAKES;
        dispatch({
            type: t,
            buyProductId:  Pricing.purchaseBothSmallGuid(state)
        });
        dispatch(push( PageUrl( actionToPage(t)) ));
        resolve(state);
    });







export const upgradeHm3AndOmahaFullStakes = state => dispatch =>
    new Promise(resolve => {
        var t = UPGRADE_HM3_AND_OMAHA_FULL_STAKES;
        let toComboAll = Pricing.upgradeToComboAllGuid(state);
        dispatch({
            type: t,
            buyProductId:  toComboAll
        });
        dispatch(push( PageUrl( actionToPage(t)) ));
        resolve(state);
    });

export const upgradeHm3AndOmahaSmallStakes = state => dispatch =>
    new Promise(resolve => {
        var t = UPGRADE_HM3_AND_OMAHA_SMALL_STAKES;
        let toComboSmall = Pricing.upgradeToComboSmallGuid(state);
        dispatch({
            type: t,
            buyProductId:  toComboSmall
        });
        dispatch(push( PageUrl( actionToPage(t)) ));
        resolve(state);
    });











export const startTrial = state => dispatch =>
    new Promise(resolve => {
        var isHm3 = state.header == HeaderType.Hm3;
        var productId = isHm3 ? ProductIds.hm3Trial : ProductIds.omahaTrial;
        ClientCall.startTrial(state.siteUrl, state.session, productId, state.fingerprint, state.enableTrialAbuseCheck, state.userId, state.email).then(value => {
            // startTrial returns an "error" answer
            dispatch({ type: SAVE_ERROR, error: value} );

            if ( value.success) {
                dispatch({
                    type: START_HM3_TRIAL,
                });
                dispatch(push(PageUrl(actionToPage(START_HM3_TRIAL))));
                CallHostApp.needsReloadLicense();
            }
            else
                // the error tells us the page to go to
                dispatch(push(PageUrl( value.page )));

            resolve(state);
        });
    });


export const startHm3AndOmahaTrial = state => dispatch => {
    return new Promise(resolve => {
        ClientCall.startTrial(state.siteUrl, state.session, ProductIds.hm3Trial, state.fingerprint, state.enableTrialAbuseCheck, state.userId, state.email)
            .then(value => {
                // startTrial returns an "error" answer
                dispatch({ type: SAVE_ERROR, error: value} );

                if (value.success)
                    return ClientCall.startTrial(state.siteUrl, state.session, ProductIds.omahaTrial, state.fingerprint, state.enableTrialAbuseCheck, state.userId, state.email);
                else
                    // basically, something went wrong starting the first trial
                    return value;
            }).then(value => {
            // startTrial returns an "error" answer
            dispatch({ type: SAVE_ERROR, error: value} );

            if (value.success) {
                dispatch({
                    type: START_HM3_AND_OMAHA_TRIAL,
                });
                dispatch(push(PageUrl(actionToPage(START_HM3_AND_OMAHA_TRIAL))));
                CallHostApp.needsReloadLicense();
            }
            else
                // the error tells us the page to go to
                dispatch(push(PageUrl( value.page )));
            resolve(state);
        });

    });
}

export const switchToFree = state => dispatch =>
    new Promise(resolve => {
        var t = SWITCH_TO_FREE;
        dispatch({
            type: t,
        });
        let url = "#";
        if ( state.missedUpdates.length > 0) {
            let last = state.missedUpdates[state.missedUpdates.length - 1];
            url = last.url;
        }
        CallHostApp.switchToFreemium(url);
        dispatch(push( PageUrl( actionToPage(t)) ));
        resolve(state);
    });

export const changeProducts = state => dispatch =>
    new Promise(resolve => {
        var t = CHANGE_PRODUCTS;
        dispatch({
            type: t,
        });
        var newPage = Page.PreSelectProducts;
        var isHm3 = state.header == HeaderType.Hm3;
        let trialAvailable = isHm3 ? state.availableTrials.hm3 : state.availableTrials.omaha;
        if ( !trialAvailable)
            newPage = Page.SelectProducts;

        dispatch(push( PageUrl( newPage) ));
        resolve(state);
    });




export const reloadLicense = () => dispatch =>
    new Promise(resolve => {
        var t = RELOAD_LICENSE;
        dispatch({
            type: t,
        });
        CallHostApp.reloadLicense();
        resolve({});
    });

export const switchUser = () => dispatch =>
    new Promise(resolve => {
        var t = SWITCH_USER;
        dispatch({
            type: t,
        });
        CallHostApp.switchUser();
        resolve({});
    });

export const startUsingApp = () => dispatch =>
    new Promise(resolve => {
        var t = START_USING_APP;
        dispatch({
            type: t,
        });
        CallHostApp.startUsingApp();
        resolve({});
    });

export const continueTrial = () => dispatch =>
    new Promise(resolve => {
        var t = CONTINUE_TRIAL;
        dispatch({
            type: t,
        });
        CallHostApp.continueTrial();
        resolve({});
    });


export const simpleHostAppAction = (action) => dispatch =>
    new Promise(resolve => {
        var t = SIMPLE_HOST_APP_ACTION;
        dispatch({
            type: t,
        });
        CallHostApp.simpleAction(action);
        resolve(action);
    });

export const sendStatusToHost = state => dispatch =>
    new Promise(resolve => {
        CallHostApp.sendHttpStatusToHost( state.licensingStatus, state.storeStatus);
        var t = SEND_HTTP_STATUS_TO_HOST;
        dispatch({
            type: t,
        });

        resolve(state);
    });

// buys a specific GUID product
export const buyGuidProduct = (guid) => dispatch =>
    new Promise(resolve => {
        var t = BUY_GUID_PRODUCT;
        dispatch({
            type: t,
            buyProductId: guid
        });
        dispatch(push( PageUrl( actionToPage(t)) ));
        resolve(guid);
    });

export const buyHmAppsVariant = (id,state) => dispatch =>
    new Promise(resolve => {
        var t = BUY_HM_APPS_VARIANT;
        dispatch({
            type: t,
            buyProductId: id
        });
        dispatch(push( PageUrl( actionToPage(t)) ));
        resolve(id,state);
    });

export const buyHmAppsVariantFree = (id,state) => dispatch =>
    new Promise(resolve => {
        var t = BUY_HM_APPS_VARIANT_FREE;

        ClientCall.purchaseFree(state,id).then(value => {
            // buyNow returns an "error" answer
            dispatch({ type: SAVE_ERROR, error: value} );

            if ( value.success) {
                dispatch(push(PageUrl( Page.PurchaseCompleteSuccess )));
                CallHostApp.needsReloadLicense();
            }
            else
                // the error tells us the page to go to
                dispatch(push(PageUrl( value.page )));

            resolve(id,state);
        });
    });


// DO NOT USE DIRECTLY
// in order to avoid an infinite loop, use clientUtil.logError
export const serverFatalError = (state, error) => dispatch =>
    new Promise(resolve => {
        var t = LOG_FATAL_ERROR;
        if ( !state.fatalErrors.includes(error)) {
            dispatch({
                type: t, errorNow: error
            });
            ClientCall.logError(state, error).then(e => {
                resolve(state);
            });
        }
        else {
            console.log("Fatal: invalid error");
            resolve(state);
        }
    });



// WEBPACK FOOTER //
// ./src/state/lic_state.js